var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C3.44771 0 3 0.447714 3 0.999997V2.75831H12.3017C12.854 2.75831 13.3017 3.20602 13.3017 3.75831V11.8102V12.976H14.8606H15C15.5522 12.976 15.9999 12.5283 15.9999 11.976V0.999996C15.9999 0.447713 15.5522 0 15 0H4ZM10.909 3.90417H1.0909C0.488415 3.90417 0 4.291 0 4.76816V15.136C0 15.6132 0.488415 16 1.0909 16H10.909C11.5115 16 12 15.6132 12 15.136V4.76816C12 4.291 11.5115 3.90417 10.909 3.90417Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f8da946a50674854b6d6952557d7a703.svg";
export { ForwardRef as ReactComponent };